import CustomScrollbar from 'components/Common/CustomScrollbar';
import TextGenerate from 'components/Common/TextGenerator';
import { copyTextToClipboard } from 'components/Dashboard/helpers/copyFunctionality';
import createMarkup from 'components/Dashboard/helpers/createMarkup';
import useTitleScrolledStyles from 'components/Dashboard/hooks/useTitleScrolledStyles';
import { ShareParliamentaryLiveContent } from 'components/Dashboard/ParliamentaryRecord/ShareParliamentaryContent';
import ParliamentaryLiveRemarksWidget, {
  getInParameter,
} from 'components/Dashboard/ParliamentLive/ParliamentaryLiveRemarksWidget';
import { ParliamentHeadingElement } from 'components/Dashboard/ParliamentLive/ParliamentLiveItem';
import ReferenceTopicWidget from 'components/Dashboard/SubNav/ReferenceTopicsWidget';
import ResearchPopUp from 'components/Dashboard/SubNav/ui/ResearchPopUp';
import preventLink from 'components/Dashboard/TagsList/prevenLink';
import getUrlParam, { decodeUrlQueryValue } from 'components/Dashboard/utilities/getUrlParam';
import { useHeightContainer } from 'components/Dashboard/utilities/useHeightContainer';
import useWindowHeight from 'components/Dashboard/utilities/useWindowHeight';
import { store } from 'components/Store';
import dayjs from 'dayjs';
import React, { useState, useRef, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { TwitterShareButton } from 'react-share';
import time from 'utils/time';

const ParliamentLiveEventContent = (props) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { activePlan, keywordsLists, referenceState } = state ?? {};

  const { embed, hits, dashboard } = props;

  const { enableAdvancedSearch } = activePlan;
  const showWidgetCondition = getUrlParam('topic-id') || getUrlParam('search') || getUrlParam('or');

  const [showPopup, setShowPopup] = useState(false);
  const [keywordsSection, setKeywordsSection] = useState('keywords');
  const [heightContainer, containerRef] = useHeightContainer();
  const [heightContainerRelatedContent, containerRefRelatedContent] = useHeightContainer();
  const [openAIassistantChat, setOpenAIassistantChat] = useState(false);
  const [reachedTheEnd, setReachedTheEnd] = useState(false);
  const contentContainer = useRef(null);

  const mainContentProps = {
    ...props,
    contentContainer,
    setReachedTheEnd,
  };

  return (
    <>
      {embed || dashboard ? (
        <>
          <div className={`h-100 ${embed ? 'px-3' : ''}`} ref={contentContainer}>
            <ParliamentLiveEventMainContent {...mainContentProps} />
          </div>
        </>
      ) : (
        <>
          <div className='row px-0 piece-content-container'>
            <div className='general-content-column padding-to-nav p-0 z-100'>
              <div ref={contentContainer}>
                <div
                  className='main-content-section content-container'
                  ref={containerRef}
                  style={{ height: `${heightContainer}px` }}
                >
                  <ParliamentLiveEventMainContent {...mainContentProps} />
                </div>
              </div>
            </div>
            {(enableAdvancedSearch || showWidgetCondition) && (
              <div className='related-content-column show-lg px-0'>
                <div className={`related-content ${openAIassistantChat ? 'related-content-open-assistant' : ''}`}>
                  <div ref={containerRefRelatedContent} />
                  <CustomScrollbar
                    className={`simple-scrollbar related-content-scroll`}
                    style={{ height: `${heightContainerRelatedContent}px` }}
                    maximalThumbYSize={100}
                  >
                    {/* <AIassistantWidget
              openAIassistantChatState={{ openAIassistantChat, setOpenAIassistantChat }}
              heightContainer={heightContainerRelatedContent}
              data={resultInformation ?? {}}
            /> */}
                    <div className='box-outstanding bg-white box-rounded mb-4 parliamentary-widget'>
                      {enableAdvancedSearch && (
                        <div className={`p-3 ${showWidgetCondition ? 'border-bottom' : ''}`}>
                          <ReferenceTopicWidget
                            keywordsLists={keywordsLists}
                            setShowPopup={setShowPopup}
                            keywordsSection={keywordsSection}
                            setKeywordsSection={setKeywordsSection}
                            includeMasterTopic={true}
                            setOpenAIassistantChat={setOpenAIassistantChat} //AE: Temporary code for removing warning - delete after final decision about ai assistant
                          />
                        </div>
                      )}
                      {showWidgetCondition && (
                        <>
                          {hits?.length > 0 ? (
                            <ParliamentaryLiveRemarksWidget reachedTheEnd={reachedTheEnd} hits={hits} />
                          ) : (
                            <div className='pl-3 py-3'>
                              <p className='mb-0'>No relevant remarks</p>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </CustomScrollbar>
                </div>
              </div>
            )}
          </div>

          <ResearchPopUp
            keywordsLists={keywordsLists.filter((item) => item.id !== null)}
            setShowPopup={setShowPopup}
            showPopUp={showPopup}
            keywordsSection={keywordsSection}
            referenceState={referenceState}
          />
        </>
      )}
    </>
  );
};

const ParliamentLiveEventMainContent = (props) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { realtimeEvents } = state ?? {};

  const {
    eventBodiesState,
    hits,
    navigateRemarks,
    eventItem,
    topicCondition,
    contentContainer,
    setReachedTheEnd,
    embed,
  } = props ?? {};
  const { eventBodies, setEventBodies } = eventBodiesState ?? {};
  const resultInformation = eventBodies?.[0];
  const realTimeEvent = realtimeEvents?.find(
    (item) => item?.parliamentEventId === resultInformation?.parliamentEventId
  );

  const scrollBarRef = useRef(null);
  const titleSection = useRef(null);
  const goTranscriptionButton = useRef(null);

  const conditionToShowGoToTranscriptionButton = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e ?? scrollBarRef?.current ?? {};
    const valueOfWhiteSpace = 200;
    return scrollTop < scrollHeight - clientHeight - valueOfWhiteSpace;
  };
  const inParameter = getUrlParam('in');
  const [scrollPosition, setScrollPosition] = useState(null);
  const [scrolling, setScrolling] = useState(false);
  const [showGoToTranscriptionButton, setShowGoToTranscriptionButton] = useState(
    conditionToShowGoToTranscriptionButton()
  );
  const [transcriptionButtonPosition, setTranscriptionButtonPosition] = useState(null);
  const [animatedItem, setAnimatedItem] = useState(null);
  const [updatingContribution, setUpdatingContribution] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const { windowWidth, windowHeight } = useWindowHeight();

  const allowScrollBottom = useRef(!inParameter && location.pathname !== '/dashboard');

  const updateExtract = useRef(null);
  updateExtract.current = (source) => {
    if (!scrolling && hits?.length > 0 && topicCondition) {
      const remarks = hits.map((item) => {
        return getInParameter({ itemUrl: item?.contentUrl });
      });

      const firstElement = hits[0];
      const elementToUse = firstElement;
      const timeParamElement = getInParameter({ itemUrl: elementToUse?.contentUrl });
      const timeId = inParameter ? decodeUrlQueryValue(inParameter) : timeParamElement;
      const id = `event-${timeId}`;
      const idElement = document.getElementById(id);
      if (idElement && remarks?.includes(timeId)) {
        //Reset class
        const className = 'parliament-live-event-highlighted';
        const elements = document.getElementsByClassName(`${className}`);
        if (elements.length) {
          Array.from(elements).forEach((element) => element.classList.remove(className));
        }
        const item = document.getElementById(id);
        const highlightedKeyword = item?.querySelector('em.policymogul-keyword-match');
        item.classList.add(className);
        const hitItem = hits?.find((hit) => {
          const parameter = getInParameter({ itemUrl: hit?.contentUrl });
          return parameter === timeId;
        });
        if (hitItem && navigateRemarks) {
          navigateRemarks({ item: hitItem, source });
        }
        setTimeout(() => {
          const valueToPosition = location?.pathname === '/dashboard' ? 80 : 140;
          //OP: Adjust scroll osition to top, to make the highlighted keyword visible
          const highlightedKeywordOffset =
            location?.pathname === '/dashboard'
              ? ((highlightedKeyword?.offsetTop > 200 ? highlightedKeyword?.offsetTop - 100 : 0) ?? 0)
              : 0;
          const position = item.offsetTop - valueToPosition - highlightedKeywordOffset;
          if (scrollBarRef && scrollBarRef.current) {
            setUpdatingContribution(true);
            scrollBarRef.current.scrollTop(position);
          }
        }, 1);
        const finalSearchParams = new URLSearchParams(location?.search);
        finalSearchParams.set('in', timeId);
        navigate({ search: finalSearchParams.toString() }, { replace: true });
        setTimeout(() => {
          setUpdatingContribution(false);
        }, 150);
      }
    }
  };

  useEffect(() => {
    const source = new AbortController();
    updateExtract.current(source);
    return () => {
      source.abort('Highlight remark cancelled by the user');
    };
  }, [location.search]);

  useEffect(() => {
    if (contentContainer?.current) {
      const { left, width, height, top } = contentContainer.current?.getBoundingClientRect();
      setTranscriptionButtonPosition({
        left: left + (width - goTranscriptionButton?.current?.getBoundingClientRect()?.width) / 2,
        top: height + top - 60,
      });
    }
  }, [contentContainer?.current, goTranscriptionButton?.current, windowWidth, windowHeight]);

  const scrollToBottom = () => {
    if (allowScrollBottom.current && !scrolling) {
      setTimeout(
        () =>
          scrollBarRef?.current?.view?.scroll({
            top: scrollBarRef?.current?.view?.scrollHeight,
            behavior: 'smooth',
          }),
        10
      );
    }
  };

  const axiosCancelToken = useRef(null);
  const eventHighlightedTime = useRef(null);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e;
    const scrolledToBottom = scrollTop === scrollHeight - clientHeight;
    setReachedTheEnd(endedEvent ? scrolledToBottom : false);
    setScrollPosition(e.scrollTop);
    setShowGoToTranscriptionButton(conditionToShowGoToTranscriptionButton(e));
    allowScrollBottom.current = scrolledToBottom;

    if (hits?.length > 0) {
      const remarks = hits.map((item) => {
        return getInParameter({ itemUrl: item?.contentUrl });
      });

      const elements = document.querySelectorAll('.parliament-live-event');
      for (let i = 0; i < elements.length; i++) {
        let el = elements[i];
        const { top } = el.getBoundingClientRect();
        const value = contentContainer.current.getBoundingClientRect().top;
        if (top >= value && top < value + 100) {
          const inParameter = el.getAttribute('id')?.replace('event-', '');
          if (
            inParameter &&
            remarks.includes(inParameter) &&
            !updatingContribution &&
            eventHighlightedTime?.current !== inParameter
          ) {
            const className = 'parliament-live-event-highlighted';
            let currentElement = document.getElementsByClassName(`${className}`)[0];
            if (currentElement) {
              currentElement.classList.remove(className);
            }
            el.classList.add(className);
            const finalSearchParams = new URLSearchParams(location?.search);
            finalSearchParams.set('in', inParameter);
            navigate(
              {
                search: finalSearchParams?.toString(),
              },
              { replace: true }
            );
            if (axiosCancelToken.current) {
              axiosCancelToken.current.abort();
            }
            axiosCancelToken.current = new AbortController();
            const hitItem = hits?.find((hit) => {
              const parameter = getInParameter({ itemUrl: hit?.contentUrl });
              return parameter === inParameter;
            });
            if (navigateRemarks) {
              navigateRemarks({ item: hitItem, source: axiosCancelToken.current });
            }
            eventHighlightedTime.current = inParameter;
            break;
          }
        }
      }
    }
  };

  const { showFixedTitle, titleStyles } = useTitleScrolledStyles({ contentContainer, titleSection });
  const endedEvent =
    !dayjs().isSame(dayjs(realTimeEvent?.scheduledStartDateTime), 'day') && !getUrlParam('startDateTime');
  const topFadeCondition = scrollPosition > 20 && realTimeEvent?.actualStartDateTime;
  const heightContainer = contentContainer?.current?.getBoundingClientRect()?.height;
  const bottomFadeCondition =
    scrollPosition + heightContainer < scrollBarRef?.current?.view?.scrollHeight - 50 &&
    realTimeEvent?.actualStartDateTime;

  const eventBodiesRef = useRef(eventBodies);

  const handleFinish = () => {
    let newEventBodies = [...eventBodiesRef.current];
    const currentItemPosition = newEventBodies.findIndex((item) => item?.objectID === animatedItem?.objectID);
    if (currentItemPosition >= 0) {
      newEventBodies[currentItemPosition] = { ...newEventBodies[currentItemPosition], notShown: false };
      const notShowItems = newEventBodies?.filter((item) => item?.notShown);
      setAnimatedItem(notShowItems?.length > 0 ? notShowItems[0] : null);
    }
    setEventBodies(newEventBodies);
  };

  useEffect(() => {
    const notShownItems = eventBodies?.filter((item) => item?.notShown);
    eventBodiesRef.current = eventBodies;
    if (!animatedItem && notShownItems?.length > 0) {
      setAnimatedItem(notShownItems[0]);
    }
  }, [eventBodies]);

  const filteredBodies = eventBodies.filter((item) => !item.notShown && item.text?.trim());
  const timeParams = filteredBodies.map((item) => getInParameter({ itemUrl: item?.contentUrl }));
  const relevantRemarkUrls = new Set(hits?.map((hit) => hit?.contentUrl));
  const currentMinutes = filteredBodies.map((item) => dayjs(item?.dateTime).format('HH:mm'));
  const showTimes = currentMinutes.map((minute, idx, arr) => {
    return idx === 0 || minute !== arr[idx - 1];
  });

  return (
    <>
      <CustomScrollbar
        ref={scrollBarRef}
        className={`simple-scrollbar indented-scrollbar-small ${topFadeCondition ? 'scrollbar-top-fade' : ''} ${
          bottomFadeCondition ? 'scrollbar-bottom-fade' : ''
        }`}
        maximalThumbYSize={100}
        onScroll={(e) => {
          handleScroll(e);
        }}
        onScrollStart={() => {
          setScrolling(true);
        }}
        onScrollStop={() => {
          setScrolling(false);
        }}
      >
        <div className='main-update-content-container'>
          <div
            className={`section-title pb-3 keyupdate-content-title content-title-with-summary content-border-title`}
            ref={titleSection}
          >
            <div className='d-flex align-items-lg-center justify-content-between'>
              <div className='pr-lg-5 pr-3 content-new-title flex-grow-1'>
                <h3 className='main-title news-title pr-lg-4 mb-0'>{eventItem?.title}</h3>
              </div>
              <ShareEventButtons eventBodies={eventBodies} eventItem={eventItem} />
            </div>

            <ParliamentHeadingElement item={eventItem} />
          </div>
          {/* FIXED TITLE */}
          <div
            className={`content-item-scrolled-title section-title bg-white ${
              showFixedTitle ? 'item-scrolled-title-visible' : ''
            }`}
            style={titleStyles}
          >
            <div className='d-flex justify-content-between scrolled-title-container'>
              <h3 className='main-title news-title pr-lg-4'>
                <span className={embed ? 'specific-x-padding-13 ' : 'font-weight-bold'}>{eventItem?.title}</span>
              </h3>
              <ShareEventButtons eventBodies={eventBodies} eventItem={eventItem} />
            </div>
          </div>
          {/* END FIXED TITLE */}
          <div className='py-4'>
            <>
              {(() => {
                return filteredBodies?.map((item, index) => {
                  const timeParam = timeParams[index];
                  const relevantRemark = relevantRemarkUrls.has(item?.contentUrl);
                  const showTime = showTimes[index];

                  return (
                    <React.Fragment key={`body-${index}`}>
                      <div
                        className={`reset-link text-main-blue px-4 d-block parliament-live-event break-word ${
                          relevantRemark ? 'parliament-live-event-relevant specific-top-padding-28 py-3' : 'py-1'
                        } ${showTime ? 'parliament-live-event-with-time' : 'parliament-live-event-without-time'}`}
                        id={`event-${timeParam}`}
                        onClick={() => {
                          const selectedText = window.getSelection().toString().trim(); // Get selected text
                          if (!selectedText) {
                            window.open(item?.sourceUrl ?? item?.contentUrl, '_blank', 'noopener,noreferrer');
                          }
                        }}
                      >
                        <ShareParliamentaryLiveContent
                          item={item}
                          additionalClass={'parliament-live-share-buttons border rounded-pill'}
                        />
                        {showTime && (
                          <p
                            className={`${
                              relevantRemark ? '' : 'specific-top-margin-6'
                            } mb-1 flex-centered main-light-text paragraph-p5`}
                          >
                            <span className='icon-clock mr-1' />
                            <span>{time(item?.dateTime)?.formatTime()}</span>
                          </p>
                        )}
                        <p
                          className='paragraph-p1 line-height-1-5 mb-0'
                          dangerouslySetInnerHTML={createMarkup(item.text)}
                        />
                      </div>
                    </React.Fragment>
                  );
                });
              })()}
              {!!animatedItem && (
                <a
                  href={animatedItem?.sourceUrl ?? animatedItem?.contentUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='reset-link text-main-blue px-4 d-block parliament-live-event py-1 break-word'
                >
                  <p className='paragraph-p1 line-height-1-5 mb-5'>
                    <TextGenerate
                      key={animatedItem?.objectID}
                      onFinish={handleFinish}
                      onCharacterAdd={(i) => {
                        if (i % 10 === 0) scrollToBottom();
                      }}
                    >
                      {animatedItem?.text}
                    </TextGenerate>
                  </p>
                </a>
              )}
            </>
            {eventItem?.transcriberRunning && <div style={{ height: 200 }} />}
          </div>
          <button
            ref={goTranscriptionButton}
            className='rounded-pill bg-main-blue px-4 py-2 general-button position-fixed text-white z-max go-to-live-transcription nowrap-item'
            style={{
              visibility: showGoToTranscriptionButton ? `visible` : 'hidden',
              opacity: !!transcriptionButtonPosition && showGoToTranscriptionButton ? 1 : 0,
              top: `${transcriptionButtonPosition?.top}px`,
              left: `${transcriptionButtonPosition?.left}px`,
            }}
            onClick={() => {
              setShowGoToTranscriptionButton(false);
              scrollBarRef?.current?.view?.scroll({
                top: scrollBarRef?.current?.view?.scrollHeight,
                behavior: 'smooth',
              });
              allowScrollBottom.current = true;
            }}
          >
            <span className='dropdown-item-element dropdown-item-element-11'>
              Go to {eventItem?.eventHasEnded ? 'end of transcription' : 'live transcription'}
            </span>
          </button>
        </div>
      </CustomScrollbar>
    </>
  );
};

const ShareEventButtons = (props) => {
  const { eventBodies, eventItem } = props;
  const url = eventBodies[0]?.sourceUrl ?? eventBodies[0]?.contentUrl ?? window.location.origin;
  return (
    <div className={`flex-centered parliament-live-share-buttons `}>
      <button
        className={`general-button position-relative share-parliamentary-content d-inline-block-centered centered-2`}
        onClick={(e) => {
          preventLink(e);
          copyTextToClipboard(url, 'Link copied');
        }}
        data-tooltip-id={'general-tooltip'}
        data-tooltip-content={'Copy link to event video'}
      >
        <span className={`icon-share-video title-h5-m`} />
      </button>

      <TwitterShareButton
        url={url}
        title={eventItem?.title}
        className='share-parliamentary-content'
        data-tooltip-id={'general-tooltip'}
        data-tooltip-content={'Share event video on X'}
      >
        <span className={`icon-twitter-x-circle`} />
      </TwitterShareButton>
    </div>
  );
};

export default ParliamentLiveEventContent;
